module.exports = __webpack_public_path__ + "media/application/images/svgs/share-5a097032fd18b48436af98767cd46d31.svg";